import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import { ChildSelector } from "../helpers/ChildSelector"

import WPCta from "./_base/WPCta"

import * as sectionImageRightWithListStyles from "../styles/SectionImageRightWithList.module.css"

export default function SectionImageRightWithList(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `section-image-right-list-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subTitle = ChildSelector.select(
    content,
    `section-image-right-list-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const introList = ChildSelector.select(
    content,
    `section-image-right-list-introList`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const introListSecond = ChildSelector.select(
    content,
    `section-image-right-list-introList-second`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "section-image-right-list-content")
    .map(t => t.text)

  const featuresList = ChildSelector.select(
    content,
    `section-image-right-list`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  const textBeforeSecondList = ChildSelector.select(
    content,
    `section-image-right-list-second-pretext`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const featuresListSecond = ChildSelector.select(
    content,
    `section-image-right-list-second`,
    ChildSelector.SELECTOR_TYPE.NODE,
  )

  const infoStack = ChildSelector.select(
    content,
    `section-image-right-list`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  const info = content.childNodes
  .filter(node => node.classNames === "section-image-right-list-info")
  .map(t => t.text)

  console.log(info)

  return (
    <div
      id={props.componentOriginalId || ``}
      className={`row ${props.className} ${sectionImageRightWithListStyles.wrapper}`}
    >
      <TwoColumnHeroWithImageRight
        contentClass={sectionImageRightWithListStyles.content}
        imageHolder={content}
        imageSelector={`media-asset`}
        imageClass={sectionImageRightWithListStyles.featureImage}
        className={sectionImageRightWithListStyles.featureGif}
        mode={CONTAINMENT_MODE.normal}
      >
        {title && (
          <h2
            className={sectionImageRightWithListStyles.title}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        )}
        {subTitle && (
          <h3
            className={sectionImageRightWithListStyles.subTitle}
            dangerouslySetInnerHTML={{
              __html: subTitle,
            }}
          />
        )}
        {textStack &&
          textStack.length > 0 &&
          textStack.map((t, idx) => (
            <p className={sectionImageRightWithListStyles.main} key={idx}>
              {t}
            </p>
          ))}

        <div
          className={`row ${props.className} ${sectionImageRightWithListStyles.listWrapper}`}
        >
          {featuresList && (
            <div
              className={`col-12 ${sectionImageRightWithListStyles.listHolder}`}
            >
              <h4 className={`${sectionImageRightWithListStyles.introList}`}>
                {introList}
              </h4>
              <ul className={`${sectionImageRightWithListStyles.content}`}>
                {featuresList &&
                  featuresList.childNodes &&
                  featuresList.childNodes.length > 0 &&
                  featuresList.childNodes.map((r, idx) => (
                    <li
                      key={idx}
                      className={`${sectionImageRightWithListStyles.contentItem}`}
                      dangerouslySetInnerHTML={{ __html: r.innerHTML }}
                    />
                  ))}
              </ul>
            </div>
          )}
          {featuresListSecond && (
            <div
              className={`col-12 ${sectionImageRightWithListStyles.listHolder}`}
            >
              {textBeforeSecondList && (
                <p className={sectionImageRightWithListStyles.main}>
                  {textBeforeSecondList}
                </p>
              )}
              <h4
                className={`${sectionImageRightWithListStyles.introListSecond}`}
              >
                {introListSecond}
              </h4>
              <ul
                className={`${sectionImageRightWithListStyles.contentSecond}`}
              >
                {featuresListSecond &&
                  featuresListSecond.childNodes &&
                  featuresListSecond.childNodes.length > 0 &&
                  featuresListSecond.childNodes.map((r, idx) => (
                    <li
                      key={idx}
                      className={`${sectionImageRightWithListStyles.contentItemSeconds}`}
                      dangerouslySetInnerHTML={{ __html: r.innerHTML }}
                    />
                  ))}
              </ul>
            </div>
          )}
          {info &&
            info.length > 0 &&
            info.map((t, idx) => (
              <p className={sectionImageRightWithListStyles.main} key={idx}>
              {t}
            </p>
          ))}
          
          {!featuresList && (
            <div
              className={`col-6 ${sectionImageRightWithListStyles.listHolder}`}
            >
              {infoStack &&
                infoStack.map((c, idx) => (
                  <p
                    key={idx}
                    className={`${sectionImageRightWithListStyles.content}`}
                    dangerouslySetInnerHTML={{ __html: c.innerHTML }}
                  />
                ))}
            </div>
          )}
        </div>
        <div className={`${sectionImageRightWithListStyles.ctaWrapper}`}>
          <WPCta
            holder={content}
            selector={`section-image-right-cta`}
            translate={false}
            className={`${sectionImageRightWithListStyles.btn}`}
            pageContext={props.pageContext}
          />
        </div>
      </TwoColumnHeroWithImageRight>
    </div>
  )
}
